import { render, staticRenderFns } from "./EditCoupons.vue?vue&type=template&id=2a15adc7&"
import script from "./EditCoupons.vue?vue&type=script&lang=js&"
export * from "./EditCoupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports